export default Object.freeze({
  POLICY_HOLDER: 'MEMBR',
  SPOUSE: 'SPS',
  DEFACTO: 'DFCT',
  EX_SPOUSE: 'EXSP',
});
